import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LoginUser } from '../common/LoginUser.type'
import { RootState } from '../common/RootState.type'

const users: LoginUser[] = []
const initialState = { users }

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<LoginUser>) => {
      state.users.push(action.payload)
    },
    removeUser: (state, action: PayloadAction<number>) => {
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
      }
    },
    editUser: (state, action: PayloadAction<LoginUser>) => {
      state.users = state.users.map((user) =>
        user.id === action.payload.id ? action.payload : user,
      )
    },
  },
})

export const selectUsers = (state: RootState) => state.user.users

export const { addUser, removeUser, editUser } = userSlice.actions
